const HOUSE_LABEL = 'Casa';
const WORK_LABEL = 'Trabalho';
const OTHER_LABEL = 'Outro';

const FIXED_LABELS = [HOUSE_LABEL, WORK_LABEL, OTHER_LABEL];

export {HOUSE_LABEL, WORK_LABEL, OTHER_LABEL, FIXED_LABELS};
